import config from '../config';

// Both helpers read `config` at CALL time, never module load: `tenantBootstrap`
// rewrites `config.baseURL` to the tenant's /t/:slug/ routes after modules are
// imported, so a URL captured at import time would hit the wrong tenant.
// Auth is global: `src/axiosSetup.ts` attaches the Bearer token to the DEFAULT
// axios instance — keep `import axios from 'axios'`; axios.create() bypasses it.
export const apiUrl = (path: string): string => `${config.baseURL}${path}`;

export const companyId = (): string => config.company;
